import { useQuery } from '@tanstack/react-query';
import { getSimuladaoBySlug } from '../queries/simuladao';

export const useGetSimuladaoBySlug = (slug: string | undefined) => {
  const { data, isError, isPending } = useQuery({
    queryKey: ['get-simuladao-by-slug', slug],
    queryFn: () => getSimuladaoBySlug(slug!),
    enabled: !!slug,
    retry: false,
  });

  return {
    data,
    isError,
    isLoading: isPending,
  };
};
